import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Small Text Extension
 *
 * Extends the default paragraph node to support small text styling.
 * Small text is rendered with xs font-size and gray color.
 *
 * Usage:
 * - Use setParagraph() for normal paragraphs
 * - Use setSmallText() for small paragraphs
 */

export interface SmallTextOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    smallText: {
      /**
       * Set the current node to small text
       */
      setSmallText: () => ReturnType;
    };
  }
}

export const SmallText = Node.create<SmallTextOptions>({
  name: "smallText",
  group: "block",
  content: "inline*",
  priority: 1000,

  addOptions() {
    return {
      HTMLAttributes: {
        class: "tiptap-small-text",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "p.tiptap-small-text",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "p",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSmallText:
        () =>
        ({ commands }) => {
          return commands.setNode(this.name);
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setSmallText(),
    };
  },
});
